// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img[data-v-3009e22a] {\n  width: 100%;\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
